module.exports = __webpack_public_path__ + "img/travel_07.7350c424.jpg";